import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.agents')
  .factory('agentLocationAPI', AgentLocationAPI);

function AgentLocationAPI(): BringozApi {
  return {
    base: `/location/agent`,
    infiniteScroll: {
      address: `/location/agent`,
      cmd: 'GET'
    }
  }
}
